module.exports = __webpack_public_path__ + "img/partA2.ce2379e3.png";